/* ── AUDIO TOGGLE ── */
(function () {
  const audio = document.getElementById('hero-audio');
  const btn   = document.getElementById('audio-toggle');
  if (!audio || !btn) return;

  const iconSound = document.getElementById('audio-icon-sound');
  const iconMute  = document.getElementById('audio-icon-mute');
  let playing = false;

  function setPlaying(val) {
    playing = val;
    if (val) {
      audio.play().catch(() => {});
      iconSound.style.display = '';
      iconMute.style.display  = 'none';
    } else {
      audio.pause();
      iconSound.style.display = 'none';
      iconMute.style.display  = '';
    }
  }

  setPlaying(false); // start muted per browser autoplay policy
  btn.addEventListener('click', () => setPlaying(!playing));
})();


/* ── VIDEO COVERFLOW ── */
(function () {
  const slides = Array.from(document.querySelectorAll('.video-slide'));
  if (!slides.length) return;

  // Labels come from section settings via window.__videoLabels, falling back to defaults
  const labels  = (window.__videoLabels && window.__videoLabels.length === 3)
    ? window.__videoLabels
    : ['01 — thin walls', '02 — suite 96', '03 — when in rome'];

  const labelEl = document.getElementById('carousel-label');
  const playBtn = document.querySelector('.vid-play');
  const muteBtn = document.querySelector('.vid-mute');
  const prevBtn = document.querySelector('.vid-prev');
  const nextBtn = document.querySelector('.vid-next');

  let current  = 0;
  let isMuted  = true;
  let isPlaying = true;
  const players = {};
  let apiReady  = false;

  // ── Layout ──
  function getState(i, active) {
    const diff = (i - active + slides.length) % slides.length;
    if (diff === 0) return 'center';
    if (diff === 1) return 'right';
    return 'left';
  }

  function render(active) {
    slides.forEach((s, i) => s.dataset.state = getState(i, active));
    if (labelEl) labelEl.textContent = labels[active];
  }

  function goTo(idx) {
    const prev = current;
    current = (idx + slides.length) % slides.length;
    render(current);
    if (apiReady && players[prev] && prev !== current) {
      try { players[prev].pauseVideo(); } catch(e) {}
    }
    if (apiReady && players[current]) {
      try {
        players[current].seekTo(0);
        players[current].playVideo();
        syncPlayIcon(true);
      } catch(e) {}
    }
  }

  render(0);

  slides.forEach((s, i) => {
    s.addEventListener('click', () => {
      if (s.dataset.state !== 'center') goTo(i);
    });
  });

  prevBtn && prevBtn.addEventListener('click', () => goTo(current - 1));
  nextBtn && nextBtn.addEventListener('click', () => goTo(current + 1));

  // ── Touch/swipe support ──
  let touchStartX = 0;
  const carousel = document.getElementById('video-carousel');
  if (carousel) {
    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
    }, { passive: true });
  }

  // ── Icon sync ──
  function syncPlayIcon(playing) {
    isPlaying = playing;
    if (!playBtn) return;
    playBtn.querySelector('.icon-play').style.display  = playing ? 'none' : '';
    playBtn.querySelector('.icon-pause').style.display = playing ? '' : 'none';
  }

  function syncMuteIcon(muted) {
    isMuted = muted;
    if (!muteBtn) return;
    muteBtn.querySelector('.icon-sound').style.display = muted ? 'none' : '';
    muteBtn.querySelector('.icon-mute').style.display  = muted ? '' : 'none';
  }

  // ── Controls ──
  playBtn && playBtn.addEventListener('click', () => {
    const p = players[current];
    if (!p || !apiReady) return;
    if (p.getPlayerState() === YT.PlayerState.PLAYING) {
      p.pauseVideo(); syncPlayIcon(false);
    } else {
      p.playVideo(); syncPlayIcon(true);
    }
  });

  muteBtn && muteBtn.addEventListener('click', () => {
    const p = players[current];
    if (!p || !apiReady) return;
    if (isMuted) {
      p.unMute(); p.playVideo();
      syncMuteIcon(false); syncPlayIcon(true);
    } else {
      p.mute(); syncMuteIcon(true);
    }
  });

  // ── YT API ──
  function initPlayers() {
    apiReady = true;
    slides.forEach((s, i) => {
      if (players[i]) return;
      players[i] = new YT.Player('yt-' + i, {
        events: {
          onReady(e) {
            e.target.mute();
            // autoplay all — browser allows muted autoplay
            e.target.playVideo();
          },
          onStateChange(e) {
            if (i !== current) return;
            syncPlayIcon(e.data === YT.PlayerState.PLAYING);
          }
        }
      });
    });
  }

  const tag = document.createElement('script');
  tag.src   = 'https://www.youtube.com/iframe_api';
  tag.async = true;
  document.head.appendChild(tag);
  const _prev = window.onYouTubeIframeAPIReady;
  window.onYouTubeIframeAPIReady = function () {
    if (_prev) _prev();
    initPlayers();
  };
  if (window.YT && window.YT.Player) initPlayers();
})();


/* ── BOTTOM NAV SCROLL SPY ── */
(function () {
  const links = document.querySelectorAll('.bottom-nav__link');
  if (!links.length) return;

  const sections = Array.from(links)
    .map(l => {
      const href = l.getAttribute('href') || '';
      if (!href.startsWith('#')) return null;
      return { el: document.getElementById(href.slice(1)), link: l };
    })
    .filter(s => s && s.el);

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const match = sections.find(s => s.el === entry.target);
      if (match) match.link.classList.toggle('is-active', entry.isIntersecting);
    });
  }, { threshold: 0.2 });

  sections.forEach(s => observer.observe(s.el));

  // smooth scroll for anchor links only
  links.forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || !href.startsWith('#')) return;
      e.preventDefault();
      const target = document.getElementById(href.slice(1));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();


/* ── CART ── */
window.cart = (function () {
  const drawer      = document.getElementById('cart-drawer');
  if (!drawer) return {};

  const overlay     = drawer.querySelector('.cart-drawer__overlay');
  const closeBtn    = drawer.querySelector('.cart-drawer__close');
  const itemsEl     = document.getElementById('cart-drawer-items');
  const emptyEl     = document.getElementById('cart-drawer-empty');
  const totalEl     = document.getElementById('cart-drawer-total');
  const countEl     = document.getElementById('cart-count');
  const drawerCount = document.getElementById('cart-drawer-count');
  const trigger     = document.getElementById('cart-trigger');

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function open() {
    fetchCart().then(renderCart);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function fetchCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  function updateCount(count) {
    if (countEl) countEl.textContent = '';
    if (drawerCount) drawerCount.textContent = '';
    if (trigger) trigger.classList.toggle('has-items', count > 0);
  }

  function renderCart(data) {
    if (!itemsEl) return;
    itemsEl.innerHTML = '';

    if (!data.items || data.items.length === 0) {
      emptyEl && (emptyEl.style.display = 'block');
      itemsEl.style.display = 'none';
      if (totalEl) totalEl.textContent = '';
      updateCount(0);
      return;
    }

    emptyEl && (emptyEl.style.display = 'none');
    itemsEl.style.display = '';

    data.items.forEach(item => {
      const el = document.createElement('div');
      el.className = 'cart-drawer__item';
      el.innerHTML = `
        <img class="cart-drawer__item-img" src="${item.image || ''}" alt="${item.title}" loading="lazy" />
        <div>
          <p class="cart-drawer__item-title">${item.product_title.toLowerCase()}</p>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-drawer__item-variant">${item.variant_title.toLowerCase()}</p>`
            : ''}
          <div class="cart-drawer__item-qty">
            <button class="cart-drawer__qty-btn" data-key="${item.key}" data-change="-1">−</button>
            <span class="cart-drawer__qty-num">${item.quantity}</span>
            <button class="cart-drawer__qty-btn" data-key="${item.key}" data-change="1">+</button>
          </div>
        </div>
        <span class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</span>
      `;
      itemsEl.appendChild(el);
    });

    if (totalEl) totalEl.textContent = formatMoney(data.total_price);
    updateCount(data.item_count);

    itemsEl.querySelectorAll('.cart-drawer__qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const key     = btn.dataset.key;
        const change  = parseInt(btn.dataset.change);
        const qtyEl   = btn.parentElement.querySelector('.cart-drawer__qty-num');
        const current = parseInt(qtyEl.textContent);
        const next    = Math.max(0, current + change);
        updateQty(key, next);
      });
    });
  }

  function updateQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => r.json())
    .then(renderCart);
  }

  // ATC from merch grid
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.merch-card__atc[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    const orig = btn.textContent;
    btn.textContent = '—';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      btn.textContent = '✓';
      setTimeout(() => { btn.textContent = orig; }, 1200);
      open();
    })
    .catch(() => { btn.textContent = orig; });
  });

  trigger   && trigger.addEventListener('click', open);
  closeBtn  && closeBtn.addEventListener('click', close);
  overlay   && overlay.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // init count on load
  fetchCart().then(data => updateCount(data.item_count));

  return { open, close, fetchCart };
})();
